App.factory('healthInsuranceSharedService', ['$q', 'baseService', 'Config', '$filter', '$rootScope', function($q, baseService, Config, $filter, $rootScope) {
    function HealthInsuranceSharedService() {
        var self = this;

        function correctCommonPersonFieldsConvertingFromHealth(person) {
            if(!person){
                return;
            }
            person.birthdate = person.birthDate;
            delete person.birthDate;
        }

        function correctCommonPersonFieldsConvertingToHealth(person) {
            if(!person){
                return;
            }

            if (person.identifierType === "OTHER") {
                person.birthDate = person.birthdate;
            } else {
                delete person.birthdate;
            }
        }

        var healthInsuranceWeightsOfTypes = [
            'REHABILITATION', 'BASIC', 'EXPANDED', 'FULL', 'VIP', 'SENIOR'
        ];

        var healthInsuranceWeightsOfVariants = [
            'SINGLE', 'PARTNER', 'FAMILY'
        ];
        this.getWeightOfPackage = function (pkg) {
            return (healthInsuranceWeightsOfVariants.indexOf(pkg.variant) + 1 ) * 100 + (healthInsuranceWeightsOfTypes.indexOf(pkg.type) + 1) * 10;
        };

        this.convertToHealth = function(data, isPartnerTypeDeclaration) {
            isPartnerTypeDeclaration = isPartnerTypeDeclaration || false;
            if (!data) {
                return data;
            }

            data = angular.copy(data);

            if (!isPartnerTypeDeclaration) {
                let children = data.children;
                children.forEach(function (child, i) {
                    correctCommonPersonFieldsConvertingToHealth(child);

                    data['child' + (i+1)] = child;
                });
            }
            delete data.children;

            let seniors = data.seniors;
            seniors.forEach(function (senior, i) {
                correctCommonPersonFieldsConvertingToHealth(senior);
                data['senior' + (i+1)] = senior;
            });
            delete data.seniors;

            correctCommonPersonFieldsConvertingToHealth(data.partner);

            correctCommonPersonFieldsConvertingToHealth(data.person);
            data.insured = data.person;
            delete data.person;
            data.hrNumber = data.insured.hrNumber;

            data.healthInsurance = data.benefit;
            delete data.benefit;

            delete data.address;

            return data;
        };

        this.convertFromHealth = function (data) {
            if (!data) {
                return data;
            }

            data = angular.copy(data);

            data.children = [];
            for (var i = 0; i < 7; i++) {
                var child = data['child' + (i + 1)];

                if (child) {
                    correctCommonPersonFieldsConvertingFromHealth(child);
                    data.children.push(child);
                }

                delete data['child' + (i + 1)];
            }

            data.seniors = [];
            for (let i = 0; i < 5; i++) {
                let senior = data['senior' + (i + 1)];

                if (senior) {
                    correctCommonPersonFieldsConvertingFromHealth(senior);
                    data.seniors.push(senior);
                }

                delete data['senior' + (i + 1)];
            }

            correctCommonPersonFieldsConvertingFromHealth(data.partner);

            correctCommonPersonFieldsConvertingFromHealth(data.insured);
            data.person = data.insured;
            delete data.insured;
            if (data.person) {
                data.person.hrNumber = data.hrNumber;
            }

            data.benefit = data.healthInsurance;
            delete data.healthInsurance;

            if (data.benefit) {
                data.benefit.benefitGroupName = $filter('healthInsuranceVariantFilter')(data.benefit.variant);
                if (data.insurer === 'PZUW') {
                    //
                } else if ($rootScope.CONFIGURATOR.healthInsuranceWithPayments.isEnabled) {
                    data.benefit.name = $filter('healthInsuranceWithPaymentsTypeFilter')(data.benefit.type);
                    data.benefit.pdf = CONFIGURATOR.healthInsuranceWithPayments.coverage[data.benefit.type];
                } else if ($rootScope.CONFIGURATOR.isHealthInsuranceEnabled) {
                    data.benefit.name = $filter('healthInsuranceTypeFilter')(data.benefit.type);
                    data.benefit.pdf = $rootScope.CONFIGURATOR.healthInsurance.catalogOfBenefitsFileUrl;
                }
                data.benefit.weight = self.getWeightOfPackage(data.benefit);
            }

            return data;
        };

    }
    return new HealthInsuranceSharedService();
}]);
